import { queryClient, useMutation } from '../../../hooks';
import { FivetranConnectionCacheKeys } from '../consts';

import * as connectionsService from '../service';

export const useFivetranConnection = () => {
  const createFivetranConnection = useMutation({
    mutationFn: connectionsService.createFivetranConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FivetranConnectionCacheKeys.GetConnections],
      });
    },
  });

  const deleteFivetranConnection = useMutation({
    mutationFn: connectionsService.deleteFivetranConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FivetranConnectionCacheKeys.GetConnections],
      });
    },
  });

  const authorizeFivetranConnection = useMutation({
    mutationFn: connectionsService.authorizeFivetranConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FivetranConnectionCacheKeys.GetConnections],
      });
    },
  });

  return {
    createFivetranConnection,
    deleteFivetranConnection,
    authorizeFivetranConnection,
  };
};
